module.exports = __webpack_public_path__ + "img/AIQuizBanner.23265f01.png";